import { fromJS } from 'immutable';
import * as actions from '../actions/ciwindow';
// import _ from 'lodash';
// import { SUCCESS, START, ERROR } from '../actions/global';
// import { fetchingState, defaultPageSize } from '@constants';

const initialStats = {
  mapData: {
    state: 'null',
    data: {
      open: false,
      selectMode: false,
      buttonStyle: 'checkbox',
      recordID: null,
      loaded: false,
      sync: true,
      zoom: 10,
      zoomChange: false,
      fullScreen: false,
      activeLayerIndex: 0,
      lastModifiedIndex: -1,
      configuration: 3,
      lat: 33.0836955,
      lng: -96.6400742,
      cameraLat: null,
      cameraLng: null,
      addressLat: null,
      addressLng: null,
      address: '',
      addresses: [],
      addressesLoaded: true,
      shortDescription: '',
      windowData: [
        {
          type: 'googlemap',
          zoom: 18,
          data: {},
        },
        {
          type: 'gismap',
          zoom: 18,
          data: {
            drawerData: {
              state: null,
              data: {},
            },
            popupData: {
              state: null,
              data: {},
            },
            queryData: {
              state: null,
              data: {},
            },
            textData: {
              state: null,
              data: [],
            },
            selectData: {
              state: null,
              data: [],
            },
          },
        },
        {
          type: 'googlemap',
          zoom: 18,
          data: {},
        },
      ],
      layerData: [
        {
          lastModifiedIndex: -1,
          configuration: 1,
          lat: 31.290626,
          lng: -98.667445,
          cameraLat: null,
          cameraLng: null,
          addressLat: 31.290626,
          addressLng: -98.667445,
          address: '',
          shortDescription: '',
          windowData: [
            {
              type: 'googlemap',
              data: {},
            },
            {
              type: 'googlemapaerial',
              data: {},
            },
            {
              type: 'googlemap',
              data: {},
            },
          ],
        },
      ],
    },
  },
};

export default (state = fromJS(initialStats), action) => {
  switch (action.type) {
    case actions.GET_APPRAISAL_SEARCH_DATA_SUCCESS: {
      let windowData = state.getIn(['mapData', 'data', 'windowData']).toJS();
      windowData[action.payload.mapDataIndex].data.queryData = {
        state: 'loaded',
        data: action.data.results,
      };
      return state.setIn(['mapData', 'data', 'windowData'], fromJS(windowData));
    }
    case actions.GET_APPRAISAL_SEARCH_DATA_ERROR: {
      let windowData = state.getIn(['mapData', 'data', 'windowData']).toJS();
      windowData[action.payload.mapDataIndex].data.queryData = {
        state: 'error',
        data: {},
      };
      return state.setIn(['mapData', 'data', 'windowData'], fromJS(windowData));
    }
    case actions.GET_APPRAISAL_SEARCH_DATA_START: {
      let windowData = state.getIn(['mapData', 'data', 'windowData']).toJS();
      windowData[action.payload.mapDataIndex].data.queryData = {
        state: 'fetching',
        data: {},
      };
      return state.setIn(['mapData', 'data', 'windowData'], fromJS(windowData));
    }
    case actions.GET_PROPERTY_SEARCH_DATA_SUCCESS: {
      let windowData = state.getIn(['mapData', 'data', 'windowData']).toJS();
      windowData[action.payload.mapDataIndex].data.drawerData = {
        state: 'loaded',
        data: action.data.results,
      };
      return state.setIn(['mapData', 'data', 'windowData'], fromJS(windowData));
    }
    case actions.GET_PROPERTY_SEARCH_DATA_START: {
      let windowData = state.getIn(['mapData', 'data', 'windowData']).toJS();
      windowData[action.payload.mapDataIndex].data.drawerData = {
        state: 'fetching',
        data: {},
      };
      return state.setIn(['mapData', 'data', 'windowData'], fromJS(windowData));
    }
    case actions.GET_PROPERTY_SEARCH_DATA_ERROR: {
      let windowData = state.getIn(['mapData', 'data', 'windowData']).toJS();
      windowData[action.payload.mapDataIndex].data.drawerData = {
        state: 'error',
        data: {},
      };
      return state.setIn(['mapData', 'data', 'windowData'], fromJS(windowData));
    }
    case actions.GET_POPUP_CONTENT_SUCCESS: {
      let windowData = state.getIn(['mapData', 'data', 'windowData']).toJS();
      if (action.payload.addition) {
        windowData[action.payload.mapDataIndex].data.popupData = {
          state: 'loaded',
          data: [
            ['Current Year', action.data.results.currentYear],
            ['Property ID', action.data.results.propertyInfo.pid],
            ['Owner Name', action.data.results.ownerInfo[0].name],
            ['Market Value', action.payload.addition.marketValue],
            ['Sale ID', action.payload.addition.saleID],
            ['Sale Price', action.payload.addition.salePriceAdjusted],
            ['Sale Ratio', action.payload.addition.salesRatioCurrent],
          ],
          propType: action.data.results.propertyInfo.propType,
        };
      } else {
        windowData[action.payload.mapDataIndex].data.popupData = {
          state: 'loaded',
          data: [
            ['Current Year', action.data.results.currentYear],
            ['Property ID', action.data.results.propertyInfo.pid],
            ['Owner Name', action.data.results.ownerInfo[0].name],
          ],
          propType: action.data.results.propertyInfo.propType,
        };
      }
      return state.setIn(['mapData', 'data', 'windowData'], fromJS(windowData));
    }
    case actions.GET_POPUP_CONTENT_START: {
      let windowData = state.getIn(['mapData', 'data', 'windowData']).toJS();
      windowData[action.payload.mapDataIndex].data.popupData = {
        state: 'fetching',
        data: {},
      };
      return state.setIn(['mapData', 'data', 'windowData'], fromJS(windowData));
    }
    case actions.GET_POPUP_CONTENT_ERROR: {
      let windowData = state.getIn(['mapData', 'data', 'windowData']).toJS();
      windowData[action.payload.mapDataIndex].data.popupData = {
        state: 'error',
        data: {},
      };
      return state.setIn(['mapData', 'data', 'windowData'], fromJS(windowData));
    }
    case actions.SET_MAPDATA: {
      return state.setIn(['mapData', 'data'], fromJS(action.windowData));
    }
    case actions.RESET_MAPDATA: {
      return state.setIn(
        ['mapData', 'data'],
        fromJS({
          open: false,
          selectMode: false,
          buttonStyle: 'checkbox',
          recordID: null,
          loaded: false,
          sync: true,
          zoom: 10,
          zoomChange: false,
          fullScreen: false,
          activeLayerIndex: 0,
          lastModifiedIndex: -1,
          configuration: 3,
          lat: 33.0836955,
          lng: -96.6400742,
          cameraLat: null,
          cameraLng: null,
          addressLat: null,
          addressLng: null,
          address: '',
          addresses: [],
          addressesLoaded: true,
          shortDescription: '',
          windowData: [
            {
              type: 'googlemap',
              zoom: 18,
              data: {},
            },
            {
              type: 'gismap',
              zoom: 18,
              data: {
                drawerData: {
                  state: null,
                  data: {},
                },
                popupData: {
                  state: null,
                  data: {},
                },
                queryData: {
                  state: null,
                  data: {},
                },
                textData: {
                  state: null,
                  data: [],
                },
                selectData: {
                  state: null,
                  data: [],
                },
              },
            },
            {
              type: 'googlemap',
              zoom: 18,
              data: {},
            },
          ],
          layerData: [
            {
              lastModifiedIndex: -1,
              configuration: 1,
              lat: 31.290626,
              lng: -98.667445,
              cameraLat: null,
              cameraLng: null,
              addressLat: 31.290626,
              addressLng: -98.667445,
              address: '',
              shortDescription: '',
              windowData: [
                {
                  type: 'googlemap',
                  data: {},
                },
                {
                  type: 'googlemapaerial',
                  data: {},
                },
                {
                  type: 'googlemap',
                  data: {},
                },
              ],
            },
          ],
        }),
      );
    }
    case actions.SET_MAPCOORDS: {
      return state
        .setIn(
          ['mapData', 'data', 'lastModifiedIndex'],
          fromJS(action.windowData.lastModifiedIndex),
        )
        .setIn(['mapData', 'data', 'lat'], fromJS(action.windowData.lat))
        .setIn(['mapData', 'data', 'lng'], fromJS(action.windowData.lng));
    }
    default:
      return state;
  }
};
